"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_NAME_VALUE = 'SET_NAME_VALUE';
exports.RESET_NAME_VALUE = 'RESET_NAME_VALUE';



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/store/name/types.ts
// module id = 374
// module chunks = 5